import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Route, Switch } from "react-router-dom";
import clsx from "clsx";
import { withStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import Drawer from "@material-ui/core/Drawer";
import Divider from "@material-ui/core/Divider";
import IconButton from "@material-ui/core/IconButton";
import ChevronLeftIcon from "@material-ui/icons/ChevronLeft";
import styles from "./Admin.Styles";
import AppBarTop from "../../components/AppBarTop";
import Nav from "../../components/Nav";
import AccountApp from "../../package/DataManagement/Account/Account.App";
import DepartmentApp from "../../package/DataManagement/Department/Department.App";
import CompanyApp from "../../package/DataManagement/Company/Company.App";
import StrategyApp from "../../package/DataManagement/Strategy/Strategy.App";
import ScenarioApp from "../../package/DataManagement/Scenario/Scenario.App";
import CustomAccountApp from "../../package/AccountManagement/CustomAccount/CustomAccount.App";
import ImportTransactionApp from "../../package/Transaction/ImportTransaction/ImportTransaction.App";
import TransactionHistoryApp from "../../package/Transaction/TransactionHistory/TransactionHistory.App";
import PrivateRoute from "../../components/PrivateRoute";
import { UserRoleTypeEnum } from "../../services/authService";
import AdminSnackbar from "../../components/AdminSnackbar";
import UnauthorizedApp from "../../package/ErrorHandler/Unauthorized/Unauthorized.App";

class AdminWrapper extends React.Component {
  state = {
    open: true
  };

  handleDrawerOpen = () => {
    this.setState({ open: true });
  };

  handleDrawerClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, error, successMessage, location } = this.props;

    let hierarchyType = null;
    let publishTrans = false;

    switch (location) {
      case "/data/account":
        hierarchyType = { id: 1, name: "Account" };
        break;
      case "/data/company":
        hierarchyType = { id: 2, name: "Company" };
        break;
      case "/data/department":
        hierarchyType = { id: 3, name: "Department" };
        break;
      case "/data/strategy":
        hierarchyType = { id: 4, name: "Strategy" };
        break;
      case "/transaction/history":
        publishTrans = true;
        break;
      default:
        break;
    }

    return (
      <div className={classes.root}>
        <CssBaseline />
        <AppBarTop
          classes={classes}
          open={this.state.open}
          handleDrawerOpen={this.handleDrawerOpen}
          hierarchyType={hierarchyType}
          publishTrans={publishTrans}
        />
        <Drawer
          variant="permanent"
          classes={{
            paper: clsx(
              classes.drawerPaper,
              !this.state.open && classes.drawerPaperClose
            )
          }}
          open={this.state.open}
        >
          <div className={classes.toolbarIcon}>
            <IconButton onClick={this.handleDrawerClose}>
              <ChevronLeftIcon />
            </IconButton>
          </div>
          <Divider />
          <Nav open={this.state.open} />
        </Drawer>
        <main className={classes.content}>
          <div className={classes.appBarSpacer} />
          <Switch>
            <PrivateRoute
              path="/data/account"
              component={AccountApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <PrivateRoute
              path="/data/department"
              component={DepartmentApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <PrivateRoute
              path="/data/company"
              component={CompanyApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <PrivateRoute
              path="/data/strategy"
              component={StrategyApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <PrivateRoute
              path="/data/scenario"
              component={ScenarioApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <PrivateRoute
              path="/account/custom"
              component={CustomAccountApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <PrivateRoute
              path="/transaction/import"
              component={ImportTransactionApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.TransactionEntry
              ]}
            />
            <PrivateRoute
              path="/transaction/history"
              component={TransactionHistoryApp}
              requiredRoles={[
                UserRoleTypeEnum.Administrator,
                UserRoleTypeEnum.TransactionEntry,
                UserRoleTypeEnum.ReadOnly
              ]}
            />
            <Route path="/unauthorized" component={UnauthorizedApp} />
          </Switch>
        </main>
        {error.validationErrors && error.validationErrors.length > 0 && (
          <AdminSnackbar
            message={error.validationErrors[0].description}
            variant="warning"
          />
        )}
        {error.status >= 500 && (
          <AdminSnackbar message={error.title} variant="error" />
        )}
        {successMessage && successMessage.message && (
          <AdminSnackbar message={successMessage.message} variant="success" />
        )}
      </div>
    );
  }
}

AdminWrapper.propTypes = {
  classes: PropTypes.object.isRequired
};

function mapStateToProps(state) {
  return {
    error: state.snackbar.error || {},
    successMessage: state.snackbar.message || {},
    location: state.router.location.pathname || ""
  };
}

export default connect(mapStateToProps)(withStyles(styles)(AdminWrapper));
